import { InterfaceState } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllInterfaceStates = () => getAllEnumOptions(InterfaceState)

export const getInterfaceStateLabel = (key?: InterfaceState) => {
  if (key === null || typeof key === 'undefined') return ''

  return InterfaceState[key]
}
